var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AfterViewInit, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environmentOm } from '../../../../environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class HopDetailReportComponent {
    constructor(reportsApi, reportHelper, route, titleService) {
        this.reportsApi = reportsApi;
        this.reportHelper = reportHelper;
        this.route = route;
        this.geomapConfig = {
            basemaps: ['streets'],
            name: 'map'
        };
        this.legData = {};
        this.error = false;
        this.errorMessage = this.reportHelper.reportErrorMessages.noReportData;
        this.isGenerating = false;
        this.isLoadingMap = false;
        this.defaultBasemap = {
            tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
            thumbnailTile: '/7/48/36',
            tileTemplate: '/{level}/{row}/{col}',
            title: 'PennDOT'
        };
        titleService.setTitle(titleService.getTitle() + ' : Hop Detail Report');
    }
    ngAfterViewInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            this.route.paramMap.subscribe(x => {
                this.objectId = JSON.parse(window.localStorage.getItem(x.get('id'))).hopId;
                this.layerId = JSON.parse(window.localStorage.getItem(x.get('id'))).layerId;
                this.loadMap();
                this.loadReport();
                this.isGenerating = false;
            });
        });
    }
    loadMap() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.isLoadingMap = true;
                yield this.mapRef.nativeElement.ready;
                yield this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
                const layerSettings = { id: parseInt(this.layerId, 10), query: { field: 'objectId', operator: '=', value: this.objectId }, zoomToLayer: true };
                this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([layerSettings]);
            }
            finally {
                this.isLoadingMap = false;
            }
        });
    }
    loadReport() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isGenerating = true;
            try {
                this.reportData = yield this.reportsApi.getHopDetailReportData(parseInt(this.objectId, 10));
                if (this.reportData.congresS_DISTRICT_NO) {
                    this.legData.congress = yield this.reportHelper.getCongressionalDistrictByName(parseInt(this.reportData.congresS_DISTRICT_NO, 10));
                }
                else {
                    this.legData.congress = null;
                }
                if (this.reportData.senatE_DISTRICT_NO) {
                    this.legData.senate = yield this.reportHelper.getSenateDistrictByName(parseInt(this.reportData.senatE_DISTRICT_NO, 10));
                }
                else {
                    this.legData.senate = null;
                }
                if (this.reportData.housE_DISTRICT_NO) {
                    this.legData.house = yield this.reportHelper.getHouseDistrictByName(parseInt(this.reportData.housE_DISTRICT_NO, 10));
                }
                else {
                    this.legData.house = null;
                }
                this.isGenerating = false;
            }
            catch (error) {
                this.isGenerating = false;
                this.error = true;
            }
        });
    }
}
